<template>
  <div class="page-container">
    <span class="app-header"></span>
    <div class="container">
      <action-panel
        message="404 Страница не найдена."
        :action-text="actionBtnText"
        @action-click="backClick"/>
      <h2></h2>
    </div>
  </div>
</template>

<script>
import ActionPanel from '@/components/ActionPanel.vue'
export default {
  name: 'TimeWindows',
  components: {
    ActionPanel
  },
  computed: {
    actionBtnText() {
      if (window.history.length > 1) return "Вернуться назад";
      return "На главную";
    }
  },
  methods: {
    backClick() {
      if (window.history.length <= 1)
        window.history.back();
      else this.$router.push('/');
    },
  },
  created() {
    document.title = "404 Страница не найдена";
  }
}
</script>